define('bizzabo/views/PollView',[
    'jquery',
    'backbone',
    'underscore',
    'bizzabo/models/Global',
    'bizzabo/bzapi',
    'bizzabo/utils',
    'bizzabo/config',
    'bizzabo/consts',
    'bizzabo/models/Poll',
    'bizzabo/models/Question',
    'bizzabo/models/Questions',
    'bizzabo/views/popup/AddPollView',
    'bizzabo/views/QuestionCollectionView',
    'bizzabo/views/popup/DeletePollView',
    'bizzabo/views/popup/DeletePollResultsView',
    'bizzabo/views/right/EditQuestionView',
    'hbars!bizzabo/templates/poll'

], function(
    $,
    Backbone,
    _,
    Global,
    BZAPI,
    UTILS,
    CONFIG,
    Consts,
    Poll,
    Question,
    Questions,
    AddPollView,
    QuestionsCollectionView,
    DeletePollView,
    DeletePollResultsView,
    EditQuestionView,
    pollTemplate
    ) {

    var PollView = Backbone.View.extend({
        events: {
            'click .addQuestionButton' : 'addQuestionButtonClicked',
            'click .poll-setting-menu-button' : 'settingsMenuButtonClicked',
            'click .poll-setting-button' : 'settingsButtonClicked',
            'click .poll-clear-button' : 'clearButtonClicked',
            'click .poll-delete-button' : 'deleteButtonClicked',
            'click .poll-duplicate-button' : 'duplicateButtonClicked',
            'click .pollStartButton' : 'pollStartButtonClicked',
            'click .pollStopButton' : 'pollStopButtonClicked'
        },

        initialize : function() {
            var questionsModel = this.model.get('questions') ? this.model.get('questions') : new Questions();
            this.questionsCollectionView = new QuestionsCollectionView({
                model: questionsModel,
                pollsView: this.options.pollsView,
                pollModel: this.model
            });

            this.activeEvent = Global.modelPool.getActiveEvent();
            this.listenTo(this.model, 'change', this.render);
            this.listenTo(this.model.get('questions'), 'add remove reset', this.render);
            this.listenTo(this.activeEvent, 'change:event-is-active', this.disableViewIfNeed);
            this.listenTo(this.activeEvent, 'change:status', this.render);
        },

        deleteButtonClicked : function() {
            var deletePollPopup = new DeletePollView(
                {
                    model: this.model,
                    title: "Delete Poll",
                    html: '<p>This will delete the poll including all the questions and results. Do you want to continue?</p>'
                });
            deletePollPopup.show();
        },

        clearButtonClicked : function() {
            var deletePollResultsPopup = new DeletePollResultsView(
                {
                    model: this.model,
                    title: "Clear Results",
                    html: '<p>All poll results will be deleted. Are you sure?</p>'
                });
            deletePollResultsPopup.show();
        },

        duplicateButtonClicked : function() {
            if (!this.model.isAllModelValid(true)) {
                this.displayErrorSaveMsg('Your poll is invalid, fix your errors before editing poll settings.');
            } else {
                this.options.pollsView.hideDetails();
                var duplicateModel = this.model.clonePoll();
                duplicateModel.set('name', duplicateModel.get('name') + ' (duplicate)');

                var pollsCollection = Global.modelPool.getPolls(this.activeEvent.get("id"));
                pollsCollection.add(duplicateModel);
                window.scrollTo(0,document.body.scrollHeight);

                new AddPollView({
                    model : duplicateModel
                }).show();
            }
        },

        pollStartButtonClicked : function() {
            if(this.$('.pollStartButton').hasClass('disabled')) {
                return;
            }

            if (!this.model.isAllModelValid(true)) {
                this.displayErrorSaveMsg('Your poll is invalid, fix your errors before editing poll settings.');
            } else {
                var oldStartTimestamp = this.model.get('start-timestamp');
                var oldEndTimestamp = this.model.get('end-timestamp');
                var thisView = this;

                var error = function() {
                    thisView.displayErrorSaveMsg("Could not start poll.");
                    thisView.model.set('start-timestamp', oldStartTimestamp);
                    thisView.model.set('end-timestamp', oldEndTimestamp);
                };

                this.model.startPollNow();
                this.model.save(null, {
                    error: error
                });
            }
        },

        pollStopButtonClicked : function() {
            if(this.$('.pollStopButton').hasClass('disabled')) {
                return;
            }

            if (!this.model.isAllModelValid(true)) {
                this.displayErrorSaveMsg('Your poll is invalid, fix your errors before editing poll settings.');
            } else {
                var oldStartTimestamp = this.model.get('start-timestamp');
                var oldEndTimestamp = this.model.get('end-timestamp');
                var thisView = this;

                var error = function() {
                    thisView.displayErrorSaveMsg("Could not stop poll.");
                    thisView.model.set('start-timestamp', oldStartTimestamp);
                    thisView.model.set('end-timestamp', oldEndTimestamp);
                };

                this.model.set('end-timestamp', Date.now());
                this.model.save(null, {
                    error: error
                });
            }
        },

        settingsButtonClicked : function() {
            if (!this.model.isAllModelValid(true)) {
                this.displayErrorSaveMsg('Your poll is invalid, fix your errors before editing poll settings.');
            } else {
                new AddPollView({
                    model : this.model
                }).show();
            }
        },

        settingsMenuButtonClicked : function() {
            this.$('.poll-setting-menu-button'). toggleClass('poll-setting-menu-button-clicked');
            this.$('.poll-setting-dropdown').toggleClass('hide');
            _.defer(function() {
                this.$('.poll-setting-dropdown').toggleClass('poll-setting-dropdown-visible');
            });

        },

        addQuestionButtonClicked : function() {
            var newQuestionModel = new Question();
            this.model.get('questions').push(newQuestionModel);
            this.options.pollsView.putRightPanelView(new EditQuestionView({
                model : newQuestionModel,
                poll : this.model,
                pollsView : this.options.pollsView
            }));
            this.options.pollsView.showDetails();
            this.options.pollsView.openDetails(true);
            this.options.pollsView.$el.removeClass('width550 width0').addClass('width440');

        },

        displayErrorSaveMsg : function(msg) {
            Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                msg : msg,
                errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.ERROR,
                autoHide : true
            });
        },

        checkIfPollOngoing : function() {
            var startTimestamp = this.model.get('start-timestamp');
            var endTimestamp = this.model.get('end-timestamp');

            if (!endTimestamp && startTimestamp) {
                return true;
            }

            var currentTime = Date.now();
            return (currentTime > startTimestamp) && (currentTime < endTimestamp)
        },

        disableViewIfNeed : function() {
            if (Global.modelPool.getActiveEvent() && Global.modelPool.getActiveEvent().get('event-is-active')) {
                this.$('.poll-setting-menu-button, a.addQuestionButton').toggleClass('hide', true);
                this.$('.button').toggleClass('disabled', true);
                this.$('.poll-questions').sortable('disable');
            } else {
                this.$('.poll-setting-menu-button, a.addQuestionButton').toggleClass('hide', false);
                this.$('.button').toggleClass('disabled', false);
                this.renderSortable();
                this.$('.poll-questions').sortable('enable');
            }
        },

        renderPollLinks : function() {
            var activeEvent = Global.modelPool.getActiveEvent();
            var isLive = activeEvent ? activeEvent.isLive() : false;
            if (isLive && this.model.has('public-url')) {
                var httpPrefix = 'http://';
                var pollUrl = this.model.get('public-url');
                var presenterUrl = pollUrl + '/wall';
                var exportUrl = CONFIG.SERVER_URL + '/api/v1/organizer/polls/' + this.model.get('id') + '/results.xls';
                var exportUrlByAttendee = CONFIG.SERVER_URL + '/api/v1/organizer/polls/' + this.model.get('id') + '/results.csv';
                this.$('.poll-url').html(pollUrl);
                this.$('.poll-url').attr('href', httpPrefix + pollUrl);
                this.$('.poll-url').removeClass('hide');
                this.$('.poll-url-empty-state').addClass('hide');
                this.$('.poll-votes-url').attr('href', httpPrefix + pollUrl + '/results?organizer=true');
                this.$('.poll-presenter-url').html(presenterUrl);
                this.$('.poll-presenter-url').attr('href', httpPrefix + presenterUrl);
                this.$('.poll-presenter-url').removeClass('hide');
                this.$('.poll-presenter-url-empty-state').addClass('hide');
                this.$('.poll-export-url').attr('href', exportUrl);
                this.$('.poll-export-url-attendee').attr('href', exportUrlByAttendee);
            }
        },

        formDragFinished : function(modelCid, index) {
            var questionsCollection = this.questionsCollectionView.model;
            var model = questionsCollection.get(modelCid);
            questionsCollection.remove(model, {
                silent : true
            });
            questionsCollection.add(model, {
                silent : true,
                at : index
            });

            var revertDrag = function() {
                this.$('.poll-questions').sortable( "cancel" );
                questionsCollection.remove(this.modelLastQuesitonDragged, {
                    silent : true
                });
                questionsCollection.add(this.modelLastQuesitonDragged, {
                    silent : true,
                    at : this.indexLastQuestionDragged
                });
            };

            if (!this.model.isAllModelValid(true)) {
                this.displayErrorSaveMsg('Your poll is invalid, fix your errors before editing poll settings.');
                revertDrag();
            } else {
                var thisView = this;
                var error = function() {
                    thisView.displayErrorSaveMsg('Could not save poll');
                    revertDrag();
                };

                this.model.save(null, {
                    error: error
                });
            }
        },

        renderSortable : function() {
            var containerEl = this.$('.poll-questions');
            var thisView = this;
            containerEl.sortable({
                handle : '.single-question-drag',

                start : function(event, ui) {
                    var cid = ui.item.find(".cid").val();
                    thisView.indexLastQuestionDragged = ui.item.index();
                    thisView.modelLastQuesitonDragged = thisView.questionsCollectionView.model.get(cid);
                },

                stop : function(event, ui) {
                    var cid = ui.item.find(".cid").val();
                    var index = ui.item.index();
                    thisView.formDragFinished(cid, index);
                }
            });
        },

        render : function() {
            var isOnGoing = this.checkIfPollOngoing();
            var jsonData = _.extend(this.model.toJSON(), {
                isOnGoing: isOnGoing,
                cid : this.model.cid,
                timeZone: Global.modelPool.getActiveEvent().get('time-zone-id'),
                renderDates: !(this.model.get('start-method') == 'manual')
            });
            var html = pollTemplate(jsonData);
            this.$el.html(html);
            this.questionsCollectionView.setElement(this.$('.poll-questions'));
            this.questionsCollectionView.render();
            this.renderPollLinks();
            this.renderSortable();
            this.disableViewIfNeed();
            return this;
        }
    });
    return PollView;

});
